export const MAX_FILE_SIZE = 5242880; // 5Mo

export const FILE_EXTENSIONS = [
  'application/pdf',
  'image/png',
  'image/jpeg',
  'image/gif',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
];

export enum ADDRESS_TYPE {
  MAIN = 'MAIN',
  SHIPPING = 'SHIPPING',
}

export enum NUMBERS {
  ONE = 1,
  TWO = 2,
  THREE = 3,
  FIVE = 5,
  TEN = 10,
  FOURTEEN = 14,
  FIFTEEN = 15,
  SEVENTEEN = 17,
  EIGHTEEN = 18,
  TWENTY = 20,
  THIRTY = 30,
  FIFTY = 50,
  ONE_HUNDRED = 100,
  FIVE_HUNDRED = 500,
}

export enum ERROR_MESSAGES {
  DEFAULT_ERROR_MESSAGE = 'form.errors.messages.reuiredField.defaultMessage',
  POORLY_FILLED_FIELD = 'form.errors.messages.poorlyFilledField',
  MAX_CHARACHTER_REACHED = 'Nombre maximum de caractères autorisés atteint',
}
